import { Pipe, PipeTransform } from '@angular/core';
import { AdminDocumentos, CadastroDocumentoTipo, ImovelDocumentos, OwnerDocument, PropertyAcquisitionDocument, PropertyOwnershipDocument } from '@usucampeao/lib-reurb-simplificado';

@Pipe({
  name: 'documentoTipo'
})
export class DocumentoTipoPipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case PropertyOwnershipDocument.PROPERTY_REGISTRATION:
        return 'Matrícula do imóvel';

      case PropertyOwnershipDocument.IPTU:
        return 'IPTU';

      case PropertyOwnershipDocument.HEALTH_CARE_CARD:
        return 'Carteira de posto de saúde';

      case PropertyOwnershipDocument.SCHOOL_ENROLLMENT:
        return 'Matrícula escolar de familiares';

      case PropertyOwnershipDocument.WATER_OR_LIGHT_BILL:
        return 'Recibo ou conta de água ou luz';

      case PropertyAcquisitionDocument.ASSIGNMENT_OF_RIGHTS_AGREEMENT:
        return 'Contrato de cessão de direitos';

      case PropertyAcquisitionDocument.DEED:
        return 'Escritura';

      case PropertyAcquisitionDocument.DONATION_CONTRACT:
        return 'Contrato de doação';

      case PropertyAcquisitionDocument.DONATION_DEED:
        return 'Escritura de doação';

      case PropertyAcquisitionDocument.FORMAL_SHARING:
        return 'Formal de partilha';

      case PropertyAcquisitionDocument.EXCHANGE_CONTRACT:
        return 'Contrato de permuta';

      case PropertyAcquisitionDocument.LAW_SUIT:
        return 'Ação judicial de usucapião';

      case PropertyAcquisitionDocument.LEASE_AGREEMENT:
        return 'Contrato de comodato';

      case PropertyAcquisitionDocument.PUBLIC_CONCESSION:
        return 'Concessão do poder público';

      case PropertyAcquisitionDocument.PURCHASE_AND_SALE_AGREEMENT:
        return 'Contrato de compra e venda';

      case PropertyAcquisitionDocument.PURCHASE_RECEIPT:
        return 'Recibo de compra';

      case PropertyAcquisitionDocument.OTHERS:
        return 'Outros';

      case PropertyAcquisitionDocument.DECLARACAO_DE_VIZINHOS:
        return 'Declaração de vizinhos';

      case PropertyAcquisitionDocument.DECLARACAO_DE_DOMICILIO:
        return 'Declaração de domicílio';

      case OwnerDocument.BIRTH_CERTIFICATE:
      case AdminDocumentos.CERTIDAO_NASCIMENTO:
        return 'Certidão de nascimento';

      case OwnerDocument.MARRIAGE_CERTIFICATE:
      case AdminDocumentos.CERTIDAO_CASAMENTO:
        return 'Certidão de casamento';

      case OwnerDocument.DIVORCE_CERTIFICATE:
      case AdminDocumentos.CERTIDAO_DIVORCIO:
        return 'Certidão de divórcio';

      case OwnerDocument.DEATH_CERTIFICATE:
      case AdminDocumentos.CERTIDAO_OBITO:
        return 'Certidão de óbito';

      case CadastroDocumentoTipo.CONTRATO:
        return 'Contrato';

      case CadastroDocumentoTipo.PROCURACAO:
        return 'Procuração';

      case CadastroDocumentoTipo.DECLARACAO_AUTONOMO:
        return 'Declaração autônomo';

      case CadastroDocumentoTipo.DECLARACAO_DOMICILIO:
        return 'Declaração domicílio';

      case CadastroDocumentoTipo.DECLARACAO_QUESTIONARIO_JURIDICO:
        return 'Declaração Questionário jurídico';

      case CadastroDocumentoTipo.DECLARACAO_VIZINHO:
        return 'Declaração vizinho';

      case AdminDocumentos.CESSAO_DIREITO:
        return 'Cessão de direitos';

      case AdminDocumentos.COMPROVANTE_CONTA:
        return 'Comprovante de conta';

      case AdminDocumentos.CONTRATO_COMPRA_VENDA:
        return 'Contrato de compra e venda';

      case AdminDocumentos.RECIBO:
        return 'Recibo';

      case AdminDocumentos.FACHADA:
        return 'Fachada';

      case AdminDocumentos.COMPROVANTE_RENDA:
        return 'Comprovante de renda';

      case AdminDocumentos.IR:
        return 'IR';

      case AdminDocumentos.HOLERITE:
        return 'Holerite';

      case AdminDocumentos.COMPROVANTE_ENDERECO:
        return 'Comprovante de endereço';

      case CadastroDocumentoTipo.COMPROVANTE_DE_RENDA:
        return 'Comprovante de renda';

      case ImovelDocumentos.PLANTA_DE_ANUENCIA:
        return 'Planta de anuência';

      case ImovelDocumentos.CROQUI_DE_AVERBACAO:
        return 'Croqui de averbação';

      default:
        return value;
    }
  }

}
